module.exports = __webpack_public_path__ + "static/media/attention-icon.889d8f9a.svg";